/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import Outlet from 'equipmentComponents/Outlet';

class EquipmentList extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    render() {
        const {
            equipment,
            sqcActions,
            sqcResults,
            orderId,
            workOrderActions,
            techInventory,
            loading,
            billingSystem,
            equipmentHitDetails,
            refreshHitDetails,
            hasWHWF,
            equipmentValidations,
            customerDetails,
            houseEquipmentDetails,
            equipmentDetails
        } = this.props;



        if (!equipment || equipment.count() === 0) {
            return null;
        }

        const rows = equipment.map((item, index) => {
            return (<Outlet
                key={`outlet_${index}`}
                outlet={item}
                loading={loading}
                sqcResults={sqcResults}
                orderId={orderId}
                techInventory={techInventory}
                workOrderActions={workOrderActions}
                sqcActions={sqcActions}
                billingSystem={billingSystem}
                equipmentHitDetails={equipmentHitDetails}
                refreshHitDetails={refreshHitDetails}
                hasWHWF={hasWHWF}
                equipmentValidations={equipmentValidations}
                customerDetails={customerDetails}
                houseEquipmentDetails={houseEquipmentDetails}
                equipmentDetails={equipmentDetails}
            />);
        });

        const result = (
            <div>
                {rows}
            </div>
        );

        return (

            <div>{result}</div>

        );
    }
}

EquipmentList.propTypes = {
    equipment: PropTypes.object,
    sqcResults: PropTypes.object,
    orderId: PropTypes.string,
    techInventory: PropTypes.object,
    workOrderActions: PropTypes.object,
    sqcActions: PropTypes.object,
    loading: PropTypes.bool,
    billingSystem: PropTypes.string,
    isSkinnyInstallType: PropTypes.bool
};
export default EquipmentList;



// WEBPACK FOOTER //
// ./src/components/equipment/EquipmentList.js